import { render, staticRenderFns } from "./AddClinician.vue?vue&type=template&id=e8828a56&"
import script from "./AddClinician.vue?vue&type=script&lang=js&"
export * from "./AddClinician.vue?vue&type=script&lang=js&"
import style0 from "./AddClinician.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports